import { StateContext } from '@ngxs/store';
import { ExhibitionStateModel } from '../exhibition.state';
import { UpdateExhibitionId } from '../exhibition.state.actions';

export const updateExhibitionId = (ctx: StateContext<ExhibitionStateModel>, action: UpdateExhibitionId) => {
    ctx.patchState({
        id: action.payload.id
    });
};
